import { render, staticRenderFns } from "./PersonIOListMob.vue?vue&type=template&id=1948a1b6&scoped=true&"
import script from "./PersonIOListMob.vue?vue&type=script&lang=js&"
export * from "./PersonIOListMob.vue?vue&type=script&lang=js&"
import style0 from "./PersonIOListMob.vue?vue&type=style&index=0&id=1948a1b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948a1b6",
  null
  
)

export default component.exports